import { createContext, useContext } from 'react'
import { DISCIPLINES, type Discipline } from '@structural-climbing/validation'

// Which disciplines this gym has, picked by a super admin. A bouldering-only
// gym shows no Lead tab, toggle or option anywhere. Defaulted to both (never
// throws) for the same reason as GymGradeConfigContext: leaf components read it
// without prop drilling and still render where no provider is mounted.
// GymLayout feeds it the value from GymContext.
export const GymDisciplinesContext = createContext<readonly Discipline[]>(DISCIPLINES)

export function useGymDisciplines(): readonly Discipline[] {
  return useContext(GymDisciplinesContext)
}
